<ng-container *transloco="let t">
    <div class="flex flex-col items-center gap-4">
        <img alt="" [ngSrc]="'/assets/icons/404.svg'" class="!w-[300px] !h-[200px]" [width]="300" [height]="200">

        <p class="text-lg text-gray-600">{{ t('order_not_found') }}</p>

        @if (showHomeBtn()) {
            <button tuiButton appearance="primary" routerLink="/" icon="svg::home">
                {{ t('go_back_home') }}
            </button>
        }
    </div>
</ng-container>
